import React, { useEffect, useState, useCallback } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { cartState, cartCountState, cartTotalState } from '../../atoms';
import { TextControl, SelectControl, CountryControl, BinaryControl } from '../InputControls';
import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import './style.css';

const stripePromise = loadStripe("pk_test_51P5aocFoScMjUSrmMEMifx7e37RBrwsxCxIH1ZIRtY4uhRPTPfranOHgIyDCO8cFoCz7hNrl6qkCfiyYs5qufHVz00KSu9qX34");

export default function CheckoutForm({ cart, close }) {

  const fetchClientSecret = useCallback(() => {
    return fetch('http://localhost:3009/create-checkout-session', {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(Object.values(cart)),
    })
      .then((res) => res.json())
      .then((data) => data.clientSecret);
  }, [cart]);

  const options = { fetchClientSecret };

  return (
    <div id="checkoutModal">
      <div id="checkoutModalContent">
        <div className='modalBack'><button onClick={close}>&larr; Go Back</button></div>
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={options}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </div>
    </div>
  )
}

